import { API_BASE } from "../config";

/**
 * Log a page view only once per session per page.
 * Uses sessionStorage to track which pages this session has already visited.
 * e.g. trackPageView("home") — will only POST on the first visit to home in this session.
 */
export default function trackPageView(page) {
  const key = `pv_${page}`;
  if (sessionStorage.getItem(key)) return; // already logged this session
  sessionStorage.setItem(key, "1");

  fetch(`${API_BASE}/analytics/pageview`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ page }),
  }).catch(() => {});
}
